module.exports = __webpack_public_path__ + "img/1557614094449713155.35c5e8fd.png";